// Main imports
import Vue from 'vue'
import Vuetify from 'vuetify'

// Global component defaults
import applyVuetifyDefaults from './vuetifyDefaults'

// Vuetify locales
import en from 'vuetify/es5/locale/en'
import es from 'vuetify/es5/locale/es'

const colors = {
  primary: '#73160E',
  secondary: '#73160E',
  accent: '#75531C'
}

// Create component
Vue.use(Vuetify)

// Must run after the install call above, which is what registers the components
applyVuetifyDefaults()

export default new Vuetify({
  lang: {
    locales: { en, es },
    current: 'en'
  },

  icons: {
    iconfont: 'mdiSvg',
    values: {
      cancel: 'mdi-close',
      prev: 'mdi-chevron-left',
      next: 'mdi-chevron-right'
    }
  },

  theme: {
    dark: false,
    themes: {
      dark: colors,
      light: colors
    },

    options: {
      customProperties: true
    }
  }
})
